export * from './fetchWrapper';
export * from './cookieYes';
export * from './checkoutDisclaimer';
export * from './localizedImage';
export * from './reviewPurchaseConversion';
export {
  resolvePLTVPriceForFlow,
  isPLTVEnabled,
  isPLValueLanding,
  resolvePLTVCountry,
  PLTV_DEFAULT_VALUE,
} from './ltvCalculator';
export * from './normalizePurchaseAmountForMeta';
export * from './upsellPurchaseQueue';
export * from './geoCurrency';
export * from './territoryPricing';
export * from './googleAdsUserData';
export * from './primaryPurchaseCompletion';
export { getPredictedLTVPrice } from './ltvCalculator';

export const removePreloader = () => {
  const pre = document.getElementById('preloader');
  if (pre) {
    pre.style.opacity = '0';
    pre.style.transition = 'opacity 0.2s ease';

    setTimeout(() => {
      pre.remove();
      const styleTag = document.getElementById('preloader-style');
      if (styleTag) styleTag.remove();
      const scriptTag = document.getElementById('preloader-script');
      if (scriptTag) scriptTag.remove();
    }, 200);
  }
};

export const scheduleRemovePreloader = () => {
  const removeWithDelay = () => setTimeout(removePreloader, 1000);
  if (document.readyState === 'complete') {
    removeWithDelay();
  } else {
    window.addEventListener('load', removeWithDelay);
  }
};

export const getRussianDayPlural = (count: number): string => {
  const remainder10 = count % 10;
  const remainder100 = count % 100;

  if (remainder100 >= 11 && remainder100 <= 14) {
    return `${count} дней`;
  }

  if (remainder10 === 1) {
    return `${count} день`;
  } else if (remainder10 >= 2 && remainder10 <= 4) {
    return `${count} дня`;
  } else {
    return `${count} дней`;
  }
};
